import React from "react";
import { Outlet } from "react-router-dom";

import { Footer, Header } from "../../components";
import "./home.scss";

export enum Tab {
  DRAW = "draw",
  PLAYBOOKS = "playbooks",
  FIELDS = "fields",
}

const tabs = Object.values(Tab);

const isAccessedViaIframe = window.self !== window.top;

export const Home = () => {
  return (
    <div className="home">
      <Header tabs={tabs} />
      <div className="app-content">
        <Outlet />
      </div>
      {!isAccessedViaIframe && <Footer />}
    </div>
  );
};
